import { render, staticRenderFns } from "./Plane.vue?vue&type=template&id=21b68982&scoped=true&"
import script from "./Plane.vue?vue&type=script&lang=js&"
export * from "./Plane.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=21b68982&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b68982",
  null
  
)

export default component.exports